import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from './user.service';
import { UserDetail } from '../models/user-detail';
import { EntityDetailResolver } from 'src/app/core/services/entity-detail.resolver';


@Injectable({ providedIn: 'root' })
export class UserDetailResolver extends EntityDetailResolver<UserService, UserDetail> {
  constructor(
    userService: UserService
  ) {
    super(userService);
  }
}
